export default __webpack_public_path__ + "static/media/Banner - EarBuddyz - White.53e5970e.jpg";